import React from 'react'
import { Player  } from 'video-react';

export default function FileVideo(props) {
    let {url}=props
    return (
        <Player
            playsInline
            startTime={200}
            // src="https://www.onegml.com/assets/videos/CDHX.mp4"
            src={url}
        >
        </Player>
    )
}
